/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Pumpspermutationhour2Inputs */



/**
* | output |
* | --- |
* | "Pumps permutation hour" |
*
* @param {Br_History_Key_Pumpspermutationhour2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_pumpspermutationhour2 = /** @type {((inputs?: Br_History_Key_Pumpspermutationhour2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Pumpspermutationhour2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pumps permutation hour")
	return /** @type {LocalizedString} */ ("Heure de permutation des pompes")
});
export { br_history_key_pumpspermutationhour2 as "br_history_key_pumpsPermutationHour" }